import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { NUS_URL } from "@util/constant";

/**
 * Component to render Centre for Governance and Sustainability, NUS Business School section on Partners page
 */
const NUSBusinessSchoolSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="nus-business-school-section-component"
    >
      <AccordionV2
        testId="nus-business-school"
        className="border-l border-r py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Centre for Governance and Sustainability, NUS Business School" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            The Centre for Governance and Sustainability (CGS), formerly known
            as Centre for Governance, Institutions and Organisations (CGIO), was
            established by the National University of Singapore (NUS) Business
            School in 2010. It aims to spearhead relevant and high-impact
            research on corporate governance (CG) and corporate sustainability
            (CS) issues that are pertinent to institutions, government bodies
            and businesses both in Singapore and Asia. This includes corporate
            governance and corporate sustainability, governance of family firms,
            government-linked companies, business groups, and institutions. CGS
            also organises events such as public lectures, industry roundtables,
            and academic conferences on topics related to governance and
            sustainability.
          </p>

          <p>
            CGS is the national assessor for the corporate governance and
            corporate sustainability performance of listed companies in
            Singapore.
          </p>

          <p>
            More information about CGS can be accessed at&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={NUS_URL}
              target="_blank"
              rel="noreferrer"
            >
              https://bschool.nus.edu.sg/cgs/
            </a>
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default NUSBusinessSchoolSection;
